import { itemMedia } from 'utils/itemMedia';

export const getRequestPayload = (
  language,
  limit,
  skip,
  selectedItem,
  mandatoryItemAttr,
  query,
  erpSystem,
) => {
  let payload = {
    erpSystem,
    language,
    limit,
    skip,
    query,
  };
  const speedControlBlockAttr = selectedItem?.attributes
    .filter(x => mandatoryItemAttr.includes(x.attributeIdentifier))
    .reduce((acc, x) => {
      acc[x.attributeIdentifier] = x.value;
      return acc;
    }, {});
  let filter = { basicForm: 'speed_control' };
  const assemblyParams = {
    attributes: speedControlBlockAttr,
  };
  return { ...payload, filter: filter, assemblyParams: assemblyParams };
};

export const transformSpeedControlBlockData = (
  speedControlBlockData,
  price,
  stock,
) => {
  return {
    items: [
      {
        description: speedControlBlockData.description,
        partNumber: speedControlBlockData.partNumber,
        brand: speedControlBlockData.brand,
        erpPartNumber: speedControlBlockData.erpPartNumber,
        descriptionMap: speedControlBlockData.descriptionMap,
        configuration: speedControlBlockData.configuration,
        image: itemMedia(speedControlBlockData.medias, [
          'product image 01',
          'product image 02',
          'item image',
        ])[0],
        quantityMeasure: speedControlBlockData.quantityMeasure,
        price: price.data.items[0],
        stockStatus: stock.data.items[0],
      },
    ],
  };
};
